import * as exConstants from './constants';
import type { TreeviewConfig } from './types';

import exTreeviewManager from './treeviewManager';

// ----------------------------------------------------------------------------

function init(config: TreeviewConfig = {}): void {
    toggle(config);
}

// ----------------------------------------------------------------------------

function toggle(config: TreeviewConfig = {}): void {
    const elements = document.querySelectorAll<HTMLElement>(exConstants.SELECTOR_DATA_TOGGLE);

    for (const element of elements) {
        element.addEventListener('click', (evt): any => {
            const target = evt.target as HTMLElement;

            const targetLink = target.closest(exConstants.SELECTOR_NAV_LINK) as HTMLAnchorElement | undefined;

            if (target.getAttribute('href') === '#' || targetLink?.getAttribute('href') === '#') {
                evt.preventDefault();
            }

            const targetItem = target.closest(exConstants.SELECTOR_NAV_ITEM) as HTMLElement | undefined;

            if (targetItem) {
                const data = new exTreeviewManager(targetItem, config);
                data.toggle();
            }
        });
    }
}

// ----------------------------------------------------------------------------

export default init;
